import { render } from "./DemoVersionList.vue?vue&type=template&id=e7de8f54&scoped=true&ts=true"
import script from "./DemoVersionList.vue?vue&type=script&lang=ts"
export * from "./DemoVersionList.vue?vue&type=script&lang=ts"

import "./DemoVersionList.vue?vue&type=style&index=0&id=e7de8f54&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7de8f54"]])

export default __exports__